export const heading = "AR Aging Dashboard Report";

export const completeListLink = "quadreport5";
